import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, emitirEscolhaPlacaPersonalizada } from './types';

export const INITIAL_STATE: emitirEscolhaPlacaPersonalizada = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): emitirEscolhaPlacaPersonalizada {
	return produce(state, draft => {
		switch (action.type) {
			case Types.EMITIR_ESCOLHA_PLACA_PERSONALIZADA_REQUEST: {
				break;
			}

			case Types.EMITIR_ESCOLHA_PLACA_PERSONALIZADA_SUCCESS: {
				draft.status = 200;
				draft.data = action.payload;
				break;
			}

			case Types.EMITIR_ESCOLHA_PLACA_PERSONALIZADA_FAILURE: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}
			case Types.EMITIR_ESCOLHA_PLACA_PERSONALIZADA_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
